import { render } from "./TransferOrderItem.vue?vue&type=template&id=67cf0d60&ts=true"
import script from "./TransferOrderItem.vue?vue&type=script&lang=ts"
export * from "./TransferOrderItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__